module.exports = __webpack_public_path__ + "img/hr-green-asterisk-15.d1b5f45a.png";